import Request from '../../services/Request';
import ResponseChecker from '../../services/ResponseChecker';


// URL //
const eachUrl = 'volunteer/getEach?';
const allUrl = 'volunteer/get?';




const state = {
  volunteers: [],
  volunteer: {},
};
const getters = {};
const mutations = {
  SET_VOLUNTEERS(state, payload) {
    state.volunteers = payload.data.data;
  },
  SET_VOLUNTEER(state, payload) {
    state.volunteer = payload.data.data;
  },
};

const actions = {
  // async getVolunteers({ commit }) {
  //   const response = await Request.get_data(allUrl)

  //   const responseChecker = new ResponseChecker(response);
  //   responseChecker.checkResponse();
  //   if (responseChecker.isResponseStatusSuccess())
  //     commit("SET_VOLUNTEERS", response);
  // },
  async getVolunteers({ commit }, payload) {
    const response = await Request.get_data(allUrl, payload)
   
    const responseChecker = new ResponseChecker(response);
    responseChecker.checkResponse();
    if (responseChecker.isResponseStatusSuccess())
      commit("SET_VOLUNTEERS", response);
  },
  async getVolunteer({ commit }, id) {
    const response = await Request.get_data(eachUrl, { column: 'id', value: id })
    const responseChecker = new ResponseChecker(response);
    responseChecker.checkResponse();
    if (responseChecker.isResponseStatusSuccess())
      commit("SET_VOLUNTEER", response);
  },
  async getVolunteerByTwnId({ commit }, id) {
    const response = await Request.get_data(allUrl, { township_id: id })
    const responseChecker = new ResponseChecker(response);
    responseChecker.checkResponse();
    if (responseChecker.isResponseStatusSuccess())
      commit("SET_VOLUNTEERS", response);
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
